import type { WavesChart } from '../wavesChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_CRIMSON } from '../builtinPulseMaps/palettes.js';
import { assembleWavesChartFromCircles } from './wavesFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/my-heart.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/my-heart-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/my-heart-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/my-heart-extreme.circles.json' with { type: 'json' };

export const MY_HEART_WAVES_VARIANTS: Record<Variant, WavesChart> = assembleWavesChartFromCircles({
  baseSlug: 'my-heart',
  baseTitle: "My Heart",
  description: "Different Heaven & EH!DE's heavy electro at 174 BPM. Fast, dense, demanding wave runs.",
  difficulty: 4,
  palette: PALETTE_CRIMSON,
  audioSrc: '/audio/waves/my-heart.mp3',
  attribution: "\"My Heart\" by Different Heaven & EH!DE [NCS Release] - https://ncs.io/MyHeart",
  mapper: "Aleycks & Sgord1",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 87, offsetMs: 0, totalBeats: 90 },
    hard: { bpm: 87, offsetMs: 0, totalBeats: 90 },
    extreme: { bpm: 87, offsetMs: 0, totalBeats: 90 },
  },
});
